import { NgModule } from '@angular/core';
import {PreloadAllModules, RouterModule, Routes} from '@angular/router';
import { DxDataGridModule } from 'devextreme-angular';
import { DxFormModule } from 'devextreme-angular';
import { EmptyLayoutComponent, MainLayoutComponent } from './layouts';
import {
    ContactUsComponent,
    LoadingComponent,
    LoginComponent,
    PasswordRecoveryComponent,
    PatientSignUpComponent,
    PrivacyComponent,
    SupplyRequestComponent,
    TermsConditionsComponent,
    UserComponent,
} from './pages';
import { FusionAuthGuard } from './shared/guard';
import {OrderExportComponent} from "./modules/features/result-export/pages/order-export/order-export.component";
import {ResultEntryAccessGuard} from "./modules/features/result-entry/guards/result-entry-access.guard";
import {
  SecretCodeInvoiceVerificationComponent
} from "./pages/security/secret-code-invoice-verification/secret-code-invoice-verification.component";


const routes: Routes = [
    {
        path: '',
        component: EmptyLayoutComponent,
        children: [
            {
                path: 'auth-callback',
                component: LoadingComponent,
            },
            {
                path: 'login',
                component: LoginComponent,
            },
            {
                path: 'password-recovery',
                component: PasswordRecoveryComponent,
            },
          {
            path: 'secret-code-verification',
            component: SecretCodeInvoiceVerificationComponent,
          },
            {
                path: 'patient-sign-up',
                component: PatientSignUpComponent,
            },
            {
                path: '',
                redirectTo: 'login',
                pathMatch: 'full',
            },
          {
            path: 'billing',
            loadChildren: () => import('./modules/features/billing/billing.module').then(m => m.BillingModule),
          }
        ],
    },
    {
        path: 'secured',
        component: MainLayoutComponent,
        children: [
            {
                path: 'support',
                children: [
                    {
                        path: 'contact-us',
                        component: ContactUsComponent,
                        canActivate: [FusionAuthGuard],
                        data: { roles: ['Superuser', 'Client Admin', 'Client Basic', 'Patient', 'Physician'] },
                    },
                    {
                        path: 'supply-request',
                        component: SupplyRequestComponent,
                        canActivate: [FusionAuthGuard],
                        data: { roles: ['Superuser', 'Client Admin', 'Client Basic'] },
                    }
                ],
            },
            {
                path: 'terms&conditions',
                component: TermsConditionsComponent,
                canActivate: [FusionAuthGuard],
                data: { roles: ['Superuser', 'Client Admin', 'Client Basic', 'Patient', 'Physician'] },
            },
            {
                path: 'privacy',
                component: PrivacyComponent,
                canActivate: [FusionAuthGuard],
                data: { roles: ['Superuser', 'Client Admin', 'Client Basic', 'Patient', 'Physician'] },
            },
            { path: 'results', loadChildren: () => import('./modules/features/results/results.module').then(m => m.ResultsModule) },
            { path: 'result-entry', loadChildren: () => import('./modules/features/result-entry/result-entry.module').then(m => m.ResultEntryModule) },
            { path: 'result-export', loadComponent: () => import('./modules/features/result-export/pages/order-export/order-export.component').then(mod => mod.OrderExportComponent), canActivate: [FusionAuthGuard], data: { roles: ['Superuser', 'Client Admin', 'Client Basic'] } },
            { path: 'requisitions', loadChildren: () => import('./modules/features/requisitions/requisitions.module').then(m => m.RequisitionsModule) },
            { path: 'standing-orders', loadChildren: () => import('./modules/features/standing-orders/standing-orders.module').then(m => m.StandingOrdersModule) },
            { path: 'patients', loadChildren: () => import('./modules/features/patient/patient.module').then(m => m.PatientModule) },
            {
                path: 'system',
                children: [
                    {
                        path: 'users',
                        component: UserComponent,
                        canActivate: [FusionAuthGuard],
                        data: { roles: ['Superuser', 'Client Admin'] },
                    },
                ],
            },
          {
            path: 'billing',
            canActivate: [FusionAuthGuard],
            data: { roles: ['Patient'] },
            loadChildren: () => import('./modules/features/billing/billing.module').then(m => m.BillingModule),
          }
        ],
        canActivate: [FusionAuthGuard],
    },
    {
        path: '**',
        redirectTo: 'secured/results/lab',
    },
];

@NgModule({
    imports: [RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules, enableTracing: false }), DxDataGridModule, DxFormModule],
    exports: [RouterModule],
    declarations: [],
})
export class AppRoutingModule {
}
